import {
  ConferenceRoomImageSrc,
  DeskImageSrc,
  ParkingSpotImageSrc,
  OtherPlaceholder
} from 'shared/assets'
import { ResourceType } from 'shared/types'

export const ImageMapping: Record<ResourceType, string> = {
  [ResourceType.ConferenceRoom]: ConferenceRoomImageSrc,
  [ResourceType.Desk]: DeskImageSrc,
  [ResourceType.ParkingSpot]: ParkingSpotImageSrc,
  [ResourceType.Locker]: DeskImageSrc,
  [ResourceType.Other]: OtherPlaceholder,
  [ResourceType.Sauna]: OtherPlaceholder,
}
